import { createSlice } from "@reduxjs/toolkit";

const loginSlice = createSlice({
  name: "auth",
  initialState: {
    isLoggedIn: false,
    token: "",
    name: "",
    userType: "",
    userId: "",
    emailId: "",
    profileImage: "",
    roleRestriction: []
  },
  reducers: {
    loginSuccess: (state, action) => {
      return {
        ...action.payload,
        isLoggedIn: true
      }


    },
    logoutSuccess: (state, action) => {
      return initialState
    },
    loginStateUpadte: (state, action) => {
      const userDetails = action.payload;
      state.name = userDetails?.name;
      state.profileImage = userDetails?.profileImage;
    },
    
  },
});

export const { loginSuccess, logoutSuccess, loginStateUpadte } =
  loginSlice.actions;

export default loginSlice.reducer;
